import React from 'react';
import { Link } from '@remix-run/react';
import { AnimatedImage } from '~/routes/_layout.about/components/animated-image';

export default function AboutPreview() {
  return (
    <section className="font-poppins bg-[url('/images/catalyst-light-bg-stoner-mobile-optimized.webp')] bg-cover bg-scroll bg-center bg-no-repeat px-2 py-16 md:px-4 lg:px-6">
      <div className="mx-auto flex w-full max-w-[100rem] flex-col space-y-16 px-4 lg:flex-row">
        <div className="flex flex-col gap-4 md:gap-6 lg:w-1/2 lg:gap-10">
          {/* Image Section */}
          <div className="text-center md:text-start">
            <AnimatedImage
              src="/images/about-catalyst-cannabis-dispensaries.webp"
              alt="About Catalyst Cannabis"
              className="w-full max-w-2xl object-contain"
              animationClass="animate-slideUp"
            />
          </div>

          {/* Text Section */}
          <div className="px-4 text-start md:px-6 lg:px-10">
            <h2 className="text-catalystdarkblue text-xl font-semibold lg:text-3xl">
              <strong>Catalyst Cannabis</strong> - Real California Cannabis
            </h2>
            <div className="mt-6 text-gray-800 lg:text-lg">
              <p>
                <strong>Catalyst</strong> is a testament to{' '}
                <strong>Real California Cannabis</strong>. In an industry rife with con men,
                grifters, bad business, and the ongoing ripple effects lingering from decades of
                prohibition, Catalyst is proof that there are still people in the space who care
                about keeping the legacy alive.
              </p>
              <p className="mt-4">
                Our founder and CEO, <strong>Elliot Lewis</strong>, wanted to be a part of the
                solution. He created a chain of retail locations beginning in 2020 with the opening
                of the Catalyst Long Beach location.{' '}
                <strong>Catalyst now boasts 29 locations with more than 500 employees</strong> in
                the four years since its inception.
              </p>
              <p className="mt-4">
                <strong>Weed For The People</strong> means we do things the right way. We treat our
                employees and customers with the respect they deserve. We go out of our way to
                ensure the products stocked on our shelves are safe. We speak out against everything
                that’s wrong with legal cannabis and we speak loudly.
              </p>
            </div>
          </div>

          {/* Button */}
          <div className="mt-8 text-center">
            <Link
              to="/about"
              className="inline-block min-h-[44px] min-w-[44px] rounded-2xl bg-red-700 px-6 py-4 text-lg font-semibold text-white transition-all duration-200 hover:bg-red-800 focus:ring-2 focus:ring-[#ffd100] focus:ring-offset-2 focus:ring-offset-red-700 focus:outline-none"
              aria-label="Read the full Catalyst story - Learn about our company"
            >
              Read the full Catalyst story
            </Link>
          </div>
        </div>

        {/* Image Section (Right) */}
        <div className="flex text-center lg:w-1/2 lg:items-center">
          <AnimatedImage
            src="/images/catalyst-company-collage-big.webp"
            alt="Catalyst Company Collage"
            className="mx-auto h-auto w-full max-w-2xl object-cover"
            animationClass="animate-slideUp"
            width={800}
            height={600}
          />
        </div>
      </div>
    </section>
  );
}
